import { Injector, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
//import {HttpModule } from '@angular/http'
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridsterModule } from "angular-gridster2";
import { CommonModule } from "@angular/common";

import { AppComponent } from "./app.component";
import {
  EmbeddedLoginComponent,
  LoginComponent,
  ChangePasswordComponent,
  RegisterComponent,
  RegistrationFormComponent,
  ActivationFormComponent,
  TwoFactorSetupComponent,
  TwoFactorValidateComponent,
  TwoFactorCertificateComponent  
} from "./insa-components/insa-login";
import { HomeComponent } from "./insa-components/insa-home";
import {
  DonutChartsComponent,
  PerformanceComponent,
  SecurityPricesComponent,
} from "./insa-components/insa-charts";
import { NewsComponent } from "./insa-components/insa-news";
import {
  MenuEntry,
  TaskList,
  MainWindowDonutChart,
  MainWindowBarChart,
  MainWindowFavorites,
  MainWindowLastUsed,
  MainWindowWelcome,
  MainWindowSearch,
  MainWindowSettings,
  InsaMainWindowComponent,
  NewHomeComponent,
} from "./insa-components/insa-main";
import {
  TransactionsComponent,
  PortfolioComponent,
  CrossRatesComponent,
  ClientContactComponent,
  LoginStatsComponent,
  EmailMapperComponent,
} from "./insa-components/insa-grids";
import { ReportComponent, MenuItemComponent } from "./insa-report";
import {
  SettingsComponent,
  PortfolioOverviewComponent,
  TilesComponent,
} from "./insa-components/insa-settings-and-tiles";
import { DashboardComponent } from "./insa-pivot";
import { RiskAssessmentComponent } from "./insa-components/insa-risk-assessment";
import { InsaTraderComponent } from "./insa-components/insa-trader/insa-trader.component";
import {
  InsaCronComponent,
  CronGenComponent,
  TimePickerComponent,
  EditJobComponent,
  EditActivitiesComponent,
  JobActivitiesListComponent,
  DeleteJobComponent,
  DeleteActivitiesComponent,
  EditInterfaceDetailsComponent,
  EditReportDetailComponent,
  EditImportDetailComponent,
  EditProcessComponent,
  EditPostActivityComponent,
  PostActionComponent,
  DeletePostActionComponent,
  ChronosJobListComponent,
  InsaTaskListComponent,
  JobLogComponent,
  EditSMSAcitivityDetailsComponent,
  EditEmailActivityDetails,
  EditTaskListActivityDetailsComponent,
  EditObjectCreationNotifierActivityDetailComponent,
  SubReportComponent,
  CopyJobComponent,
} from "./insa-components/insa-cron";
import {
  LocalizeService,
  ClientContactService,
  RiskAssessmentService,
  InsaMetadataService,
  InsaCronService,
  TaskListService,
  InsaService,
  InsaMainService,
  AuthService,
  PartnerEmailService,
  TwoFactorService
} from "./insa-services";
import { appStateProvider } from "./insa-providers";
import { setAppInjector } from "./insa-custom-scripts";

import { AppRoutingModule } from "./app-routing.module";
import { GenericFormModule } from "./insa-components/insa-generic-form/generic-form.module";
import { VideoCallClientComponent } from "./insa-components/insa-login/video-call/video-call-client.component";
import { VideoCallManagerComponent } from "./insa-components/insa-login/video-call/video-call-manager.component";
import { ExampleFormComponent } from "./insa-components/insa-generic-form/example-form.component";
import { StandaloneFilePickerExample } from "./insa-components/insa-generic-form/standalone-file-picker-example.component";

let schemas: any[] = [];

//use CUSTOM_ELEMENTS_SCHEMA to supress unknown element errors
schemas.push(CUSTOM_ELEMENTS_SCHEMA);

@NgModule({
  declarations: [
    InsaTraderComponent,
    SettingsComponent,
    TilesComponent,
    LoginComponent,
    ReportComponent,
    NewsComponent,
    InsaMainWindowComponent,
    MenuEntry,
    TaskList,
    MainWindowDonutChart,
    MainWindowBarChart,
    MainWindowWelcome,
    MainWindowSearch,
    MainWindowSettings,
    NewHomeComponent,
    MainWindowFavorites,
    MainWindowLastUsed,
    EditPostActivityComponent,
    DeletePostActionComponent,
    HomeComponent,
    TransactionsComponent,
    DonutChartsComponent,
    PerformanceComponent,
    PortfolioComponent,
    CrossRatesComponent,
    SecurityPricesComponent,
    MenuItemComponent,
    PortfolioOverviewComponent,
    ChangePasswordComponent,
    ClientContactComponent,
    AppComponent,
    DashboardComponent,
    EmbeddedLoginComponent,
    CronGenComponent,
    TimePickerComponent,
    InsaCronComponent,
    DeleteJobComponent,
    DeleteActivitiesComponent,
    EditJobComponent,
    InsaTaskListComponent,
    ChronosJobListComponent,
    PostActionComponent,
    JobActivitiesListComponent,
    EditActivitiesComponent,
    JobLogComponent,
    EditInterfaceDetailsComponent,
    EditReportDetailComponent,
    EditImportDetailComponent,
    EditProcessComponent,
    RiskAssessmentComponent,
    EditSMSAcitivityDetailsComponent,
    EditEmailActivityDetails,
    EditTaskListActivityDetailsComponent,
    EditObjectCreationNotifierActivityDetailComponent,
    EditTaskListActivityDetailsComponent,
    LoginStatsComponent,
    SubReportComponent,
    RegisterComponent,
    RegistrationFormComponent,
    ActivationFormComponent,
    EmailMapperComponent,
    VideoCallClientComponent,
    VideoCallManagerComponent,
    ExampleFormComponent,
    CopyJobComponent,
    TwoFactorSetupComponent,
    TwoFactorValidateComponent,
    TwoFactorCertificateComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    GridsterModule,
    GenericFormModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    appStateProvider,
    AuthService,
    LocalizeService,
    TaskListService,
    ClientContactService,
    RiskAssessmentService,
    InsaMetadataService,
    InsaService,
    InsaCronService,
    InsaMainService,
    Title,
    PartnerEmailService,
    TwoFactorService
  ],
  schemas: schemas,
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
}



// WEBPACK FOOTER //
// ./app/app.module.ts